export default __webpack_public_path__ + "static/media/02_ice_m.605cd521.webp";